import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import {
    Box,
    Grid,
    Card,
    CardActionArea,
    CardContent
  } from "@mui/material";
  import Typography from "@mui/material/Typography";

// estilos
import { styled } from "@mui/material/styles";

// importados
import Accion from "../../components/Accion";
import Impresiones from "./Impresiones";
import BotonSeguir from "./BotonSeguir";

const Div = styled("div")(({ theme }) => ({
    marginBottom: 15,
  }));
  
  const Alerta = styled(Alert)(({ theme }) => ({
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
      marginBottom: 15,
      color: "#799f4f",
    },
  }));
  
  const Div2 = styled("div")(({ theme }) => ({
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  }));

  
const DatosBasicos = (props) => {
  // seteos

  return (
    <>
        <Card sx={{ padding: 1 }}>
              <CardActionArea>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <Typography variant="titulo">
                        {props.tema}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} align="right">
                      <Box sx={{ display: "flex", flexDirection: "row-reverse" }} >
                        <Accion funcion={props.funcionImp} accion="Impresiones">
                          <Impresiones
                            idTramite={props.tramiteid}
                            tipo={props.tramite_expediente}
                            soporte={props.soporte}
                            permiso={props.permiso}
                            permisos={props.tienePermisoAdjunto2}
                          ></Impresiones>
                        </Accion>
                        <BotonSeguir tramiteId={props.tramiteid} />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="cuerpo">
                          <b>Asunto:</b> {props.asunto}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="cuerpo">
                          <b>Tramitado en:</b>{" "}
                          {props.iniciador +
                            " (" +
                            props.iniciador_id +
                            ")"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="cuerpo">
                          <b>Visibilidad:</b> {props.visibilidad}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="cuerpo">
                          <b>Soporte:</b> {props.soporte}
                        </Typography>
                      </Box>
                    </Grid>

                    {props.soporte === "PAPEL" ? (
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="cuerpo">
                            <b>Folios:</b> {props.cant_folios}
                          </Typography>
                        </Box>
                      </Grid>
                    ) : (
                        ""
                      )}
                    {props.observacion ? (
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="cuerpo">
                            <b>Observaciones:</b> {props.observacion}
                          </Typography>
                        </Box>
                      </Grid>
                    ) : (
                        ""
                      )}
                  </Grid>
                </CardContent>
              </CardActionArea>
            </Card>
    </>
  );
};

export default DatosBasicos;